// Single source of truth for the signed-in company's profile, used by the
// invoice generator and anywhere else that needs the tenant's own details.
// Merges the Settings-saved profile over the onboarding profile.

const EMPTY = {
  name: '', tagline: '', email: '', phone: '', website: '',
  gstin: '', address: '', city: '', state: '', pincode: '', country: 'India',
  logo: '',                 // data URL
  services: [],             // string[]
  bank: { accName: '', accNumber: '', bank: '', branch: '', ifsc: '' },
};

export function getCompanyProfile() {
  let profile = null, onboarding = null;
  try { profile = JSON.parse(localStorage.getItem('ryzenos_company_profile') || 'null'); } catch {}
  try { onboarding = JSON.parse(localStorage.getItem('ryzenos_company') || 'null'); } catch {}
  const merged = { ...EMPTY, ...(onboarding || {}), ...(profile || {}) };
  merged.bank = { ...EMPTY.bank, ...((onboarding && onboarding.bank) || {}), ...((profile && profile.bank) || {}) };
  if (!Array.isArray(merged.services)) merged.services = [];
  return merged;
}

export function saveCompanyProfile(data) {
  const current = getCompanyProfile();
  const next = { ...current, ...data, bank: { ...current.bank, ...(data.bank || {}) } };
  localStorage.setItem('ryzenos_company_profile', JSON.stringify(next));
  return next;
}

export { EMPTY as EMPTY_COMPANY };
